export default {
    name: "VoucherPromo",
    data() {
        return {
            isHeadPromoVisible: false,
        };
    },
};
